import React from "react";

import FacebookIcon from "../../../assets/images/facebook.svg";
import FooterIcon from "../../../assets/images/footer_equipbid_icon.png";
import InstagramIcon from "../../../assets/images/instagram.svg";
import LinkInIcon from "../../../assets/images/linkedIn.svg";
import TwitterIcon from "../../../assets/images/twitter.svg";
import YoutubeIcon from "../../../assets/images/youtube.svg";

const EquipBidFooter = () => {
  return (
    <div id="EquipBid__Footer">
      <div className="top-footer-part">
        <div>
          <h4>About EquipNow</h4>
          <p>What is EquipNow?</p>
          <p>Our Team</p>
          <p>Careers</p>
          <p>Blog</p>
          <p>News/Press Releases</p>
          <p>Terms Of Service</p>
          <p>Privacy Policy</p>
          <p>Site Map</p>
        </div>

        <div>
          <h4>Support</h4>
          <p>Product Releases</p>
          <p>Suggest A Feature</p>
          <p>How To Buy?</p>
          <p>How To Sell?</p>
          <p>Platform Health</p>
          <p>Help & Support</p>
          <p>FAQs</p>
          <p>Accessibility</p>
        </div>

        <div>
          <h4>Services</h4>
          <p>EquipLogistics</p>
          <p>EquipFinance</p>
          <p>EquipInspection</p>
          <p>EquipValuations</p>
          <p>EquipFinder</p>
          <p>Asset Management</p>
          <p>Subscriptions</p>
        </div>

        <div>
          <h4>Partner With EquipNow</h4>
          <p>Become A Partner</p>
          <p>Partnerships</p>
          <p>Investor Relations</p>
        </div>

        <div>
          <h4>Connect With Us</h4>
          <p>Toll-Free: (866) 859-5678</p>

          <h4>Subscribe To Our Newsletter</h4>
          <input placeholder="xyz@demo.com"/>
        </div>
      </div>

      <hr/>

      <div className="bottom-footer-part">
        <img src={FooterIcon}/>

        <h6>Copyright © EquipNow 2021</h6>

        <div className="icons-block">
          <img src={FacebookIcon}/>
          <img src={TwitterIcon}/>
          <img src={LinkInIcon}/>
          <img src={InstagramIcon}/>
          <img src={YoutubeIcon}/>
        </div>
      </div>
    </div>
  );
};

export default EquipBidFooter;
